<template>
   <section class="about__area pt-90 pb-150">
      <div class="container">
          <div class="row course__img w-img">
            <div class="course__slider swiper-container pb-40">
               <!-- <img width="300" style="width: 100%; height: 100%; border-radius: 10px;" :src="baseUrl + news.image" alt=""> -->
                
               <swiper 
                  ref="mySwiper" 
                  class="pb-50" 
                  :space-between="25" 
                  :slides-per-view="(sortSlideImage?.length > 1) ? 2 : 1" 
                  :modules="modules" 
                  :pagination="{ clickable: true }" 
                  :loop="true" 
                  :effect="'fade'" 
                  :autoplay="{ delay: 1000 }"
                  :breakpoints="(sortSlideImage?.length > 1) ? breakpoints2 : breakpoints1"
                  >
                  <swiper-slide v-for="(vm, index) in sortSlideImage" :key="index">
                     <div class="course__item course__item-3 swiper-slide white-bg mb-30 fix">
                        <div class="course__thumb w-img p-relative fix">
                           <img width="300" height="600" style="width: 100%; height: 100%;" :src="baseUrl + vm.menus_image" alt="">
                        </div>
                     </div>
                  </swiper-slide>
               </swiper>
               <div class="swiper-pagination"></div>
            </div>
         </div>
         <div class="row">
            <div class="col-12">
               <div class="about__content pl-10 pr-10 pt-25">
                  <div class="about__list mb-35">
                     <span v-html="dynamicPage"></span>
                  </div>
               </div>
            </div>
         </div>
        
         <!-- <pre>{{ pagesImages }}</pre> -->
         <p v-if="!!pages?.employees?.length"
            style="font-size: 20px; color: black; font-weight: bold; font-family: DaunPenh, sans-serif;">
            {{
               getName({
                  nameUz: 'Hodimlar',
                  nameRu: 'Сотрудники',
                  nameEn: 'Employees',
               })
            }}
         </p>
         <div class="row">
            <div v-for="(vm, index) in pages?.employees ?? []" :key="index" class="col-lg-4 col col-md-6 col-12">
               <div class="teacher__item flex text-center grey-bg-5 transition-3 mb-30">
                  <div class="teacher__thumb w-img fix">
                     <img height="350" style="object-fit:cover; object-position: center; border-radius: 6px;"
                        :src="baseUrl + vm.image" alt="">
                  </div>
                  <div class="teacher__content" style="height: 220px;">
                     <h2 class="teacher__title">
                        {{
                           getName({
                              nameUz: vm.full_name_uz ?? '',
                              nameRu: vm.full_name_ru ?? '',
                              nameEn: vm.full_name_en ?? '',
                           })
                        }}
                     </h2>
                     <br>
                     <span>
                        {{
                           getName({
                              nameUz: vm.postion_uz ?? '',
                              nameRu: vm.postion_ru ?? '',
                              nameEn: vm.postion_en ?? '',
                           })
                        }}
                     </span>
                     <br>
                     <div class="d-flex items-center mt-2">
                        <img width="22" style="margin-right: 6px;" src="../../assets/img/phone.png" alt="">
                        <span>{{ vm.phone ?? '' }}</span>
                     </div>

                     <div class="d-flex items-center my-2">
                        <img width="22" style="margin-right: 6px;" src="../../assets/img/email.png" alt="">
                        <span>{{ vm.email ?? '' }}</span>
                     </div>

                     <div class="d-flex items-center">
                        <img width="22" style="margin-right: 6px;" src="../../assets/img/time.png" alt="">
                        <span>
                           {{
                              getName({
                                 nameUz: vm.res_uz ?? '',
                                 nameRu: vm.res_ru ?? '',
                                 nameEn: vm.res_en ?? '',
                              })
                           }}
                        </span>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </section>
</template>

<script>
import BlogMixin from '../../mixins/blogMixin';
import { Swiper, SwiperSlide } from "swiper/vue";
import { Pagination } from "swiper";
import { mapActions, mapGetters } from 'vuex';
export default {
   name: 'AboutArea',
   mixins: [BlogMixin],
   components: {
      Swiper,
      SwiperSlide,
   },
   props: {
      pages: {
         type: Object,
         default: {}
      }
   },
   data() {
      return {
         id: this.$route.params.id,
         course: {},
         breakpoints2: {
            550: { slidesPerView: 1, },
            768: { slidesPerView: 2, },
            992: { slidesPerView: 2, },
         },
         breakpoints1: {
            550: { slidesPerView: 1, },
            768: { slidesPerView: 1, },
            992: { slidesPerView: 1, },
         },
      }
   },
    created() {
        this.getPagesImages();
    },
   computed: {
      ...mapGetters('pagesImages', ['pagesImages']),
      sortSlideImage(){
         return this.pagesImages.filter((x)=> x.menu == this.pages.menu)
      },
      dynamicPage() {
         return this.getName({ nameRu: this.pages.text_ru, nameEn: this.pages.text_en, nameUz: this.pages.text_uz })
      },
   },
      methods: {
      ...mapActions('pagesImages', ['getPagesImages']),
    },
   setup() {
      return {
         modules: [Pagination],
      };
   },
};
</script>
